import React from "react";
import { BRAND } from "@/lib/links";

// Use the actual uploaded LD monogram artwork. The PNG was supplied on a black
// canvas; we render it directly when the surface is dark and apply CSS mix-mode
// when needed on lighter surfaces so we don't ship a separate light asset.

export const LogoMark = ({ size = 36 }) => (
  <img
    src={BRAND.monogramOnDark}
    alt=""
    aria-hidden="true"
    width={size}
    height={size}
    style={{
      width: size,
      height: size,
      objectFit: "contain",
      display: "block",
    }}
  />
);

export const LogoCompact = ({ light = false }) => {
  const color = light ? "#F5F0E8" : "#1C1A17";
  return (
    <div className="inline-flex items-center gap-3.5">
      <span
        className="inline-flex items-center justify-center"
        style={{
          width: "32px",
          height: "32px",
          background: light ? "transparent" : "#1C1A17",
          borderRadius: "2px",
          overflow: "hidden",
        }}
      >
        <LogoMark size={28} />
      </span>
      <div className="flex flex-col leading-none">
        <span
          className="font-serif"
          style={{
            color,
            fontSize: "1.05rem",
            letterSpacing: "0.18em",
            fontWeight: 400,
            lineHeight: 1,
          }}
        >
          Liz Dirocco
        </span>
        <span
          className="block mt-1.5"
          style={{ width: "26px", height: "1px", background: "#B89A6E" }}
          aria-hidden="true"
        />
      </div>
    </div>
  );
};

export const Logo = ({ light = false, withTagline = true }) => {
  const color = light ? "#F5F0E8" : "#1C1A17";
  return (
    <div className="inline-flex flex-col items-start gap-4">
      <span
        className="inline-flex items-center justify-center"
        style={{
          width: "56px",
          height: "56px",
          background: light ? "transparent" : "#1C1A17",
          borderRadius: "2px",
          overflow: "hidden",
        }}
      >
        <LogoMark size={48} />
      </span>
      <div className="flex flex-col items-start">
        <span
          className="font-serif"
          style={{
            color,
            fontSize: "1.25rem",
            letterSpacing: "0.22em",
            textTransform: "uppercase",
            fontWeight: 400,
          }}
        >
          Liz Dirocco
        </span>
        <span
          className="block mt-2"
          style={{ width: "32px", height: "1px", background: "#B89A6E" }}
          aria-hidden="true"
        />
        {withTagline && (
          <span
            className="mt-3"
            style={{
              color: light ? "#D9C4A0" : "#B89A6E",
              fontSize: "0.58rem",
              letterSpacing: "0.32em",
              textTransform: "uppercase",
              fontWeight: 500,
            }}
          >
            Strategic Banking · Infinite Possibilities
          </span>
        )}
      </div>
    </div>
  );
};
